exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".t_row:after {\n  content: '';\n  clear: both;\n  display: table; }\n\n.t_col {\n  float: left;\n  width: 100%;\n  margin-right: 3px;\n  margin-top: 2px; }\n\n@media screen and (min-width: 767px) and (max-width: 991px) {\n  .t_col {\n    width: 49.5%; } }\n\n@media screen and (min-width: 992px) {\n  .t_col {\n    width: 19.5%; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/components/graphs/trend-map/trend-map.component.scss
// module id = ../../../../../src/app/shared/components/graphs/trend-map/trend-map.component.scss
// module chunks = main